import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import AppDetail from "./components/AppDetail";
import AppDetail2 from "./components/AppDetail2";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Hero from "./components/Hero";
import Download from "./components/Download";

export default function App() {
  return (
    <div id="app" className="bg-gray-50 text-lg min-h-screen font-nunito text-blue-gray-900">
      <Header />
      <Hero />
      <main className="max-w-4xl my-0 mx-auto">
        <About />
        {/* <AppDetail />
        <AppDetail2 /> */}
        <Download />
        <PrivacyPolicy />
        {/* <Support /> */}
      </main>
      <Footer />
    </div>
  );
}
